export default __webpack_public_path__ + "static/media/product.cc89c1c7.svg";